/**
 * A custom accordion component
 *
 * @component
 */

import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js"
flatpickr.localize(German);

class DatePicker {

    constructor() {

        if ($('[data-datepicker]').length === 0) return;

        $('[data-datepicker]').each(function (i, component) {

            let options = $(component).data('datepicker');

            if (options == '' || options === undefined) options = [];

            options.altInput = true;
            options.altFormat = "d.m.Y";

            if (typeof options.allowInput === 'undefined') options.allowInput = true;
            if (typeof options.dateFormat === 'undefined') options.dateFormat = "d.m.Y";

            if (options.allowInput === true) {

                options.onOpen = function (selectedDates, dateStr, instance) {

                    this._input.onkeydown = function () { // if user uses backspace to clear the date, trigger the clear function.
                        var key = event.keyCode || event.charCode;
                        if (key == 8 || key == 46) {
                            instance.clear();
                        }
                    };
                };

                options.onChange = function (selectedDates, dateStr) {
                    this._selDateStr = dateStr;
                };
                options.onClose = function (selelectedDates, dateStr, instance) {
                    if (this.config.allowInput && this._input.value && this._input.value !== this._selDateStr) {
                        this.setDate(this.altInput.value, false, this.config.altFormat);
                    }
                };
            }

            $(component).flatpickr(options);

        });

    }

}

export default new DatePicker();
